import Countries from '../constants/countries';
var countryToLangCode = function (countryName) {
    switch (countryName) {
        case Countries.ARGENTINA:
        case Countries.URUGUAY:
            return 'es-AR';
        case Countries.DOMINICANA:
            return 'es-DO';
        case Countries.ECUADOR:
            return 'es-EC';
        default:
            // eslint-disable-next-line no-console
            console.warn('Missing langCode for country', countryName);
            return 'es';
    }
};
export var CountryUtils = { countryToLangCode: countryToLangCode };
